<template>
  <div style="width: 100%">
    <v-row class="justify-center ma-2">
      <v-spacer />
      <v-col
        cols="6"
        md="4"
      >
        <v-select
          v-model="currentComponent"
          :items="tiposVisualizacao"
          item-text="name"
          item-value="component"
          label="Selecione o tipo de monitoramento"
        />
      </v-col>
    </v-row>
    <v-row class="justify-center ma-2">
      <keep-alive>
        <component
          :is="currentComponent"
          :key="currentComponent"
          :mapeamento="mapeamento"
        />
      </keep-alive>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MonitoramentoGeralComportamento from '@/components/monitoramento/mapeamento/MonitoramentoGeralComportamento';
import MonitoramentoGeralCompetenciaComportamental
from '@/components/monitoramento/mapeamento/MonitoramentoGeralCompetenciaComportamental';

export default {
  name: 'MonitoramentoMapeamentoGeralComportamental',

  components: { MonitoramentoGeralComportamento, MonitoramentoGeralCompetenciaComportamental },

  props: {
    mapeamento: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      tiposVisualizacao: [
        { name: 'Comportamentos', component: 'MonitoramentoGeralComportamento' },
        { name: 'Competências Comportamentais', component: 'MonitoramentoGeralCompetenciaComportamental' },
      ],
      currentComponent: 'MonitoramentoGeralComportamento',
      currentComponentKey: 'MonitoramentoGeralComportamento',
    };
  },

  computed: {
    ...mapState({
      relatorio: (state) => state.monitoramento.mapeamento.relatorio,
      graficosGeral: (state) => state.monitoramento.mapeamento.graficosGeral,
    }),
  },
};
</script>
